import React from 'react'

import { AppState } from '../types'
import { NavigationState } from '../modules/navigation/types'
import { connect } from 'react-redux'
import { Link } from '../modules/navigation/containers'

class App extends React.Component {

  render() {
    return (
      <div>
        Default
        <Link route="other">Go to other</Link>
      </div>
    )
  }

}

const mapStateToProps = (state: AppState): { navigation: NavigationState } => ({
  navigation: state.navigation
})

export default connect(mapStateToProps)(App)
